import React from 'react';
import { X } from 'lucide-react';

export const NabihCertificatePopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[95vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 sm:p-6 border-b bg-white shrink-0">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 flex-1 min-w-0">
            NABH Certificate - Quality Standards
          </h2>
          <button
            onClick={onClose}
            className="ml-4 flex-shrink-0 p-2 sm:p-3 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors border border-gray-300 min-w-[44px] min-h-[44px] flex items-center justify-center"
          >
            <X className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-4 sm:p-6">
            <div className="text-center mb-6">
              <p className="text-sm sm:text-lg text-gray-600 mb-4">
                We are proud to be NABH certified, ensuring the highest standards of healthcare quality and patient safety.
              </p>
            </div>

            {/* Certificate Image Placeholder */}
            <div className="bg-gray-100 rounded-lg p-6 sm:p-8 flex items-center justify-center min-h-[300px] sm:min-h-[400px]">
              <div className="text-center">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <p className="text-gray-500 text-base sm:text-lg font-semibold">
                  NABH Certificate Image
                </p>
                <p className="text-gray-400 text-xs sm:text-sm mt-2">
                  Certificate image will be displayed here
                </p>
              </div>
            </div>

            {/* Certificate Details */}
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              <div className="bg-blue-50 rounded-lg p-4">
                <h3 className="font-semibold text-blue-900 mb-2 text-sm sm:text-base">What is NABH?</h3>
                <p className="text-blue-800 text-xs sm:text-sm">
                  NABH is National Accreditation Board for Hospitals & Healthcare Providers. 
                  It sets standards for quality healthcare and patient safety in India.
                </p>
              </div>
              <div className="bg-green-50 rounded-lg p-4">
                <h3 className="font-semibold text-green-900 mb-2 text-sm sm:text-base">Benefits for Patients</h3>
                <ul className="text-green-800 text-xs sm:text-sm list-disc list-inside space-y-1">
                  <li>Highest quality care standards</li>
                  <li>Patient safety protocols</li>
                  <li>Transparent processes</li>
                  <li>Continuous quality improvement</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end p-4 sm:p-6 border-t bg-gray-50 shrink-0">
          <button
            onClick={onClose}
            className="px-6 py-2 sm:py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold text-sm sm:text-base min-w-[80px] min-h-[44px] flex items-center justify-center"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};